import React, { useState } from "react";
import { Link } from "gatsby";
import {useLocation } from '@reach/router';

function DropdownMenu() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const handleMouseEnter = () => {
    setIsMenuOpen(true);
  };

  const handleMouseLeave = () => {
    setIsMenuOpen(false);
  };

  const location = useLocation();
  const lang = location.pathname.startsWith("/en") ? "en" : "nl";

  return (
    <div
      className="relative hidden lg:inline-block text-left"
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
<div className="relative inline-flex font-inter font-semibold px-3 py-2 group cursor-pointer hover:no-underline">
  <span className="relative z-10">
    {lang === "en" ? "Destinations" : "Bestemmingen"}
  </span>
  <span className="absolute bottom-0 left-3 w-0 h-[2px] bg-current transition-all duration-300 group-hover:w-[calc(100%-1.5rem)]"></span>
</div>

      {isMenuOpen && (
        <div
          className="fixed left-0 w-full bg-white shadow-lg ring-1 ring-black ring-opacity-5 z-99 font-inter mt-1"
        >
          <div className="max-w-screen-lg mx-auto grid grid-cols-4 gap-x-3 gap-y-6 p-6 text-sm font-semibold"> {/* Gecentreerd met max-w-screen-lg en mx-auto */}
            
            {/* Frankrijk sectie */}
            <div>
              <Link to="/surfvakanties/frankrijk">
              <h3 className="text-lg mb-2">
                {lang === "en" ? "France" : "Frankrijk"}
                </h3>
              </Link>

              <ul className="list-none text-slate-500">
                <li className="ml-0 mb-1">
                  <Link to="/surfvakanties/frankrijk/moliets" >
                    Moliets
                  </Link>
                </li>
                <li className="ml-0 mb-1">
                  <Link to="/surfvakanties/frankrijk/mimizan">
                    Mimizan
                  </Link>
                </li>
                <li className="ml-0 mb-1">
                  <Link to="/surfvakanties/frankrijk/biarritz">
                    Biarritz
                  </Link>
                </li>
                <li className="ml-0 mb-1">
                  <Link to="/surfvakanties/frankrijk/vieux-boucau">
                    Vieux Boucau
                  </Link>
                </li>
              </ul>
           

            {/* Spanje sectie */}
          
              <Link to="/surfvakanties/spanje">
              <h3 className="text-lg mb-2">
                {lang === "en" ? "Spain" : "Spanje"}
                </h3>
              </Link>

              <ul className="list-none text-slate-500">
              <li className="ml-0 mb-1">
                  <Link to="/surfvakanties/spanje/zarautz">
                    Zarautz
                  </Link>
                </li>
                <li className="ml-0 mb-1">
                  <Link to="/surfvakanties/spanje/san-sebastian">
                    San Sebastian
                  </Link>
                </li>
                <li className="ml-0 mb-1">
                  <Link to="/surfvakanties/spanje/cantabrie">
                    {lang === "en" ? "Cantabria" : "Cantabrië"}
                  </Link>
                </li>
              </ul>
       

            {/* Canarische Eilanden sectie */}
            <Link to="/surfvakanties/spanje/canarische-eilanden">
              <h3 className="text-lg mb-2">
                {lang === "en" ? "Canary Islands" : "Canarische Eilanden"}
                </h3>
              </Link>
              
              <ul className="list-none text-slate-500">
              <li className="ml-0 mb-1">
                  <Link to="/surfvakanties/spanje/fuerteventura">
                    Fuerteventura
                  </Link>
                </li>
                <li className="ml-0 mb-1">
                  <Link to="/surfvakanties/spanje/lanzarote">
                    Lanzarote
                  </Link>
                </li>
                <li className="ml-0 mb-1">
                  <Link to="/surfvakanties/spanje/tenerife">
                    Tenerife
                  </Link>
                </li>
                <li className="ml-0 mb-1">
                  <Link to="/surfvakanties/spanje/gran-canaria">
                    Gran Canaria
                  </Link>
                </li>
              </ul>
            </div>

            {/* Portugal sectie */}
            <div>
              <Link to="/surfvakanties/portugal">
              <h3 className="text-lg mb-2">Portugal</h3>
              </Link>
              <ul className="list-none text-slate-500">
              <li className="ml-0 mb-1">
                  <Link to="/surfvakanties/portugal/porto">
                    Porto
                  </Link>
                </li>
                <li className="ml-0 mb-1">
                  <Link to="/surfvakanties/portugal/tocha">
                    Tocha
                  </Link>
                </li>

                <li className="ml-0 mb-1">
                  <Link to="/surfvakanties/portugal/figueira-da-foz">
                    Figueira da Foz
                  </Link>
                </li>

                <li className="ml-0 mb-1">
                  <Link to="/surfvakanties/portugal/peniche">
                    Peniche
                  </Link>
                </li>
                        
                <li className="ml-0 mb-1">
                  <Link to="/surfvakanties/portugal/ericeira">
                    Ericeira
                  </Link>
                </li>
                <li className="ml-0 mb-1">
                  <Link to="/surfvakanties/portugal/lissabon">
                    {lang === "en" ? "Lisbon" : "Lissabon"}
                  </Link>
                </li>
                <li className="ml-0 mb-1">
                  <Link to="/surfvakanties/portugal/vila-nova-de-milfontes">
                    Vila Nova de Milfontes
                  </Link>
                </li>

                <li className="ml-0 mb-1">
                  <Link to="/surfvakanties/portugal/aljezur">
                   Aljezur
                  </Link>
                </li>
              </ul>

              

              <Link to="/surfvakanties/marokko">
              <h3 className="text-lg mb-2">
                
                {lang === "en" ? "Morocco" : "Marokko"}
                </h3>
              </Link>

              <ul className="list-none text-slate-500">
              <li className="ml-0 mb-1">
                  <Link to="/surfvakanties/marokko/imsouane">
                    Imsouane
                  </Link>
                </li>
                <li className="ml-0 mb-1">
                  <Link to="/surfvakanties/marokko/tamraght">
                    Tamraght
                  </Link>
                </li>
                <li className="ml-0 mb-1">
                  <Link to="/surfvakanties/marokko/taghazout">
                    Taghazout
                  </Link>
                </li>
              </ul>


              <Link to="/surfvakanties/egypte">
              <h3 className="text-lg mb-2">
                {lang === "en" ? "Egypt" : "Egypte"}
                </h3>
              </Link>

              <ul className="list-none text-slate-500">
              <li className="ml-0 mb-1">
                  <Link to="/surfvakanties/egypte/el-gouna">
                    El Gouna
                  </Link>
                </li>
              </ul>

              <Link to="/surfvakanties/zuid-afrika">
              <h3 className="text-lg mb-2">
                {lang === "en" ? "South Africa" : "Zuid-Afrika"}
                </h3>
              </Link>

              <ul className="list-none text-slate-500">

                <li className="ml-0 mb-1">
                  <Link to="/surfvakanties/zuid-afrika/kaapstad">
                  {lang === "en" ? "Cape Town" : "Kaapstad"}
                  </Link>
                </li>
              </ul>
            </div>

            {/* Costa Rica en andere bestemmingen */}
            <div>
            <Link to="/surfvakanties/costa-rica">
              <h3 className="text-lg mb-2">Costa Rica</h3>
            </Link>

              <ul className="list-none text-slate-500">
              <li className="ml-0 mb-1">
                  <Link to="/surfvakanties/costa-rica/tamarindo">
                    Tamarindo
                  </Link>
                </li>
                <li className="ml-0 mb-1">
                  <Link to="/surfvakanties/costa-rica/santa-teresa">
                    Santa Teresa
                  </Link>
                </li>
              </ul>
              <Link to="/surfvakanties/mexico">
              <h3 className="text-lg mb-2">Mexico</h3>
              </Link>

              <ul className="list-none text-slate-500">
              <li className="ml-0 mb-1">
                  <Link to="/surfvakanties/mexico/puerto-escondido">
                    Puerto Escondido 
                  </Link>
                </li>
              </ul>

              <Link to="/surfvakanties/nicaragua">
              <h3 className="text-lg mb-2">Nicaragua</h3>
              </Link>

              <ul className="list-none text-slate-500">
              <li className="ml-0 mb-1">
                  <Link to="/surfvakanties/nicaragua/san-juan-del-sur">
                    San Juan del Sur
                  </Link>
                </li>
              </ul>
            

             <Link to="/surfvakanties/ecuador">
              <h3 className="text-lg mb-2">Ecuador</h3>
              </Link>

              <ul className="list-none text-slate-500">
              <li className="ml-0 mb-1">
                  <Link to="/surfvakanties/ecuador/montanita">
                    Montañita
                  </Link>
                </li>
              </ul>
            </div>

            {/* Sri Lanka en Indonesië */}
            <div>
            <Link to="/surfvakanties/sri-lanka">
              <h3 className="text-lg mb-2">Sri Lanka</h3>
            </Link>

              <ul className="list-none text-slate-500">
              <li className="ml-0 mb-1">
                  <Link to="/surfvakanties/sri-lanka/ahangama">
                    Ahangama
                  </Link>
                </li>
              </ul>

              <Link to="/surfvakanties/indonesie">
              <h3 className="text-lg mb-2">
                {lang === "en" ? "Indonesia" : "Indonesië"}
                </h3>
              </Link>

              <ul className="list-none text-slate-500">
              <li className="ml-0 mb-1">
                  <Link to="/surfvakanties/indonesie/bali">
                    Bali
                  </Link>
                </li>
                <li className="ml-0 mb-1">
                  <Link to="/surfvakanties/indonesie/lombok">
                    Lombok
                  </Link>
                </li>
                <li className="ml-0 mb-1">
                  <Link to="/surfvakanties/indonesie/mentawai">
                    Mentawai
                  </Link>
                </li>
              </ul>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default DropdownMenu;
